import { Tooltip } from '@mui/material';
import { Typography } from '@peritasai/ui-components';

const truncateSx = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  display: 'block',
  width: '100%',
  minWidth: 0,
};

export const renderTableCell = (value: unknown, bold = false, emptyText = 'N/A') => {
  const text = value != null && String(value).trim() !== '' ? String(value) : emptyText;
  return (
    <Tooltip title={text} disableHoverListener={!text || text === emptyText}>
      <Typography variant={bold ? 'body2Strong' : 'body2'} sx={truncateSx}>
        {text}
      </Typography>
    </Tooltip>
  );
};

export const renderDateCell = (value: unknown, emptyText = 'N/A') =>
  renderTableCell(typeof value === 'string' ? new Date(value).toLocaleDateString() : null, false, emptyText);
